var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disabled-comment text-center"},[_vm._v("\n  Please "),_c('a',{attrs:{"href":_vm.registerLink}},[_vm._v("register")]),_vm._v(" or "),_c('a',{attrs:{"href":_vm.signInLink}},[_vm._v("sign in")]),_vm._v(" to reply\n")])}
var staticRenderFns = []

export { render, staticRenderFns }